import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Button, Spin, Result, Typography, Space, Tag, Divider } from 'antd';
import { CheckCircleTwoTone, MessageOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

// Landing pública — não usa api service (não precisa auth)
const API_BASE = process.env.REACT_APP_API_URL || 'https://admin-api.futezap.com.br/api';

const PublicReactivate = () => {
  const { code } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [confirming, setConfirming] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [talkSent, setTalkSent] = useState(false);
  const [sendingTalk, setSendingTalk] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API_BASE}/reativar/${encodeURIComponent(code)}`);
        const j = await r.json();
        if (!r.ok) throw new Error(j.error || 'erro');
        setData(j);
        if (j.already_redeemed) setConfirmed(true);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [code]);

  const confirm = async () => {
    setConfirming(true);
    try {
      const r = await fetch(`${API_BASE}/reativar/${encodeURIComponent(code)}/confirm`, { method: 'POST' });
      const j = await r.json();
      if (!r.ok) throw new Error(j.error || 'erro');
      setConfirmed(true);
    } catch (err) {
      setError(err.message);
    } finally { setConfirming(false); }
  };

  const wantTalk = async () => {
    setSendingTalk(true);
    try {
      const r = await fetch(`${API_BASE}/reativar/${encodeURIComponent(code)}/talk`, { method: 'POST' });
      const j = await r.json();
      if (!r.ok) throw new Error(j.error || 'erro');
      setTalkSent(true);
    } catch (err) {
      setError(err.message);
    } finally { setSendingTalk(false); }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 80 }}><Spin size="large" /></div>;

  if (error === 'cupom_expirado') {
    return (
      <Result status="warning" title="Este link expirou"
        subTitle="Nos escreva no WhatsApp para verificarmos novas condições." />
    );
  }
  if (error === 'cupom_nao_encontrado' || error) {
    return (
      <Result status="404" title="Link inválido"
        subTitle="Verifique o link recebido ou entre em contato com o suporte." />
    );
  }

  if (confirmed) {
    return (
      <div style={{ maxWidth: 640, margin: '40px auto', padding: 24 }}>
        <Result icon={<CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 72 }} />}
          title="Show! Fechado então 🎉"
          subTitle="Recebi sua confirmação e já avisei a galera. Em minutos você recebe o PIX com o desconto lá no seu zap. Qualquer coisa é só me chamar, boleiro."
        />
      </div>
    );
  }

  if (talkSent) {
    return (
      <div style={{ maxWidth: 640, margin: '40px auto', padding: 24 }}>
        <Result icon={<MessageOutlined style={{ fontSize: 72, color: '#1890ff' }} />}
          title="Fechou! Já te chamo 💬"
          subTitle="Recebi teu recado. Em alguns minutos alguém aqui do time (talvez eu mesmo) te chama no zap pra entender melhor. Fica tranquilo que a condição continua valendo enquanto a gente papeia."
        />
      </div>
    );
  }

  const priceDesc = data.plan_price * (1 - data.discount_percent / 100);

  return (
    <div style={{ maxWidth: 680, margin: '40px auto', padding: 24 }}>
      <Card>
        <Space direction="vertical" size={4} style={{ marginBottom: 8 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>Uma mensagem pessoal</Text>
          <Title level={3} style={{ margin: 0 }}>
            Fala, irmão! ⚽
          </Title>
        </Space>

        <Paragraph style={{ marginTop: 16, fontSize: 15 }}>
          Marcos do Futezap por aqui.
        </Paragraph>

        <Paragraph style={{ fontSize: 15 }}>
          Faz um tempo que a gente não se fala. Antes de qualquer coisa, foi top o tempo que você organizou o fute com a gente.
        </Paragraph>

        <Paragraph style={{ fontSize: 15 }}>
          Sei que às vezes o time se desfaz, dá aquela pausa e depois volta. Também sei que pode ter passado alguma instabilidade ou problema no uso, por isso estou passando por aqui.
        </Paragraph>

        <Paragraph style={{ fontSize: 15 }}>
          Ah, e uma parada: a gente evoluiu bastante o produto, melhorou a infra e tá ouvindo cada vez mais quem organiza. Tá rolando também o pré-lançamento do nosso gerenciador de campeonatos, o <a href="https://copanamao.com.br" target="_blank" rel="noreferrer"><Text strong>Copa na Mão</Text></a> — dá uma passada lá pra ver.
        </Paragraph>

        <Paragraph style={{ fontSize: 15 }}>
          Se foi problema, aceite minhas desculpas. Se foi por outro motivo, veja se faz sentido voltar.
        </Paragraph>

        <Paragraph style={{ fontSize: 15 }}>
          Pra dar aquela força, tô passando um incentivo, um descontinho nos próximos meses:
        </Paragraph>

        <Card size="small" style={{ background: '#fff7e6', border: '2px dashed #faad14', marginTop: 8 }}>
          <Space direction="vertical" size={12} style={{ width: '100%' }}>
            <div><Text strong style={{ fontSize: 18 }}>🎁 Condição especial</Text></div>
            <div>
              <Tag color="gold" style={{ fontSize: 16, padding: '6px 14px' }}>
                {data.discount_percent}% OFF por {data.discount_months} meses
              </Tag>
            </div>
            <div>
              Plano <Text strong>{data.plan_name}</Text>. De <Text delete>R$ {data.plan_price.toFixed(2)}</Text> por{' '}
              <Text strong style={{ fontSize: 20, color: '#52c41a' }}>R$ {priceDesc.toFixed(2)}/mês</Text>
            </div>
          </Space>
        </Card>

        <Divider style={{ margin: '24px 0 16px' }} />

        <Paragraph style={{ fontSize: 15, marginBottom: 8 }}>
          <Text strong>Como quer seguir, irmão?</Text>
        </Paragraph>

        <Space direction="vertical" size={12} style={{ width: '100%' }}>
          <Button type="primary" size="large" loading={confirming} onClick={confirm}
            style={{ width: '100%', height: 52, fontSize: 16 }}>
            ⚡ Bora voltar
          </Button>
          <Button size="large" icon={<MessageOutlined />} loading={sendingTalk} onClick={wantTalk}
            style={{ width: '100%', height: 48, fontSize: 15 }}>
            Antes quero papear. Me chama no zap
          </Button>
        </Space>

        <Divider style={{ margin: '24px 0 16px' }} />

        <Paragraph style={{ fontSize: 13, color: '#666', margin: 0 }}>
          Se quiser trocar uma ideia, só me chamar 🙏
        </Paragraph>

        <div style={{ marginTop: 20, textAlign: 'right' }}>
          <Text style={{ fontStyle: 'italic', color: '#333' }}>
            Abraço, irmão.<br />
            <Text strong>Marcos Sanches</Text><br />
            <Text type="secondary" style={{ fontSize: 12 }}>Fundador do Futezap</Text>
          </Text>
        </div>

        <Text type="secondary" style={{ display: 'block', marginTop: 20, fontSize: 11, textAlign: 'center' }}>
          Oferta válida até {new Date(data.expires_at).toLocaleDateString('pt-BR')}
        </Text>
      </Card>
    </div>
  );
};

export default PublicReactivate;
